$(document).on('turbo:load turbo:render',() => {

    $(".hide-address-fields").hide();

});